import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircleIcon, EyeOffIcon } from 'lucide-react';
export function SolutionsFailSection() {
  const attempts = ['Leíste los libros. Los subrayaste. Sabés la teoría de memoria.', 'Fuiste al retiro. Volviste distinto tres semanas, y después volviste a lo mismo.', 'Meditación, podcasts, afirmaciones, planes de entrenamiento, dietas.'];
  return <section id="solutions" className="py-14 md:py-32 bg-charcoal" data-id="element-314" data-mp="th7xnyo1zlrq">
      <div className="max-w-4xl mx-auto px-6" data-id="element-315" data-mp="y86j1cnwfa1u">
        <FadeIn data-id="element-316" data-mp="y8yd2j1ukzq0">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-sand mb-8 md:mb-12 text-center" data-id="element-317" data-mp="y9hkv6xsa7qb">
            Por qué no funcionó antes
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-318" data-mp="oj6hpmlxc2kh">
          <FadeIn direction="right" data-id="element-319" data-mp="ai2hrby6nme0">
            <div className="space-y-6 text-lg text-offwhite-dim" data-id="element-320" data-mp="aj42k8503n8x">
              <p className="text-xl font-heading font-bold text-offwhite" data-id="element-321" data-mp="fhylda2yxbt1">
                Ya intentaste cambiarlo. Y volviste al mismo lugar.
              </p>
              <p data-id="element-322" data-mp="1fwn6nzn9ewfr">
                No fue por falta de disciplina ni de información. Tenés más
                información de la que necesitás.
              </p>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.15} data-id="element-323" data-mp="1ot4hf1rposaz">
            <ul className="space-y-4" data-id="element-324" data-mp="1jxgu6rwsi984">
              {attempts.map(item => <li key={item} className="flex items-start gap-4 bg-charcoal-dark p-4 rounded-sm border border-charcoal-light" data-id="element-325" data-mp="w6bau2rn4yt2">
                  <XCircleIcon className="w-6 h-6 text-amber shrink-0 mt-0.5" data-id="element-326" data-mp="15wcri9hnzexy" />
                  <span className="text-offwhite-dim text-sm md:text-base" data-id="element-327" data-mp="15yh5xld6vwch">
                    {item}
                  </span>
                </li>)}
            </ul>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} className="mt-10 md:mt-16 max-w-3xl mx-auto text-center" data-id="element-328" data-mp="8h8m6ayla5p2">
          <div className="bg-charcoal-dark border border-charcoal-light p-8 md:p-12 rounded-sm" data-id="element-329" data-mp="28k02jo1wi2tn">
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-charcoal border border-sand/30 mb-6" data-id="element-330" data-mp="2di1kg5nlbw3j">
              <EyeOffIcon className="w-7 h-7 text-sand" data-id="element-331" data-mp="2iambizf43v3d" />
            </div>
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-offwhite mb-6 leading-tight" data-id="element-332" data-mp="2n8ntti4prqds">
              El problema no es la información. Es que estás intentando verte en
              un espejo que no existe.
            </h3>
            <p className="text-lg text-offwhite-dim" data-id="element-333" data-mp="1ujz1o8lmyve6">
              El punto ciego no se ve solo. Por definición: si lo vieras, no
              sería ciego. Podés leer cien libros sobre tu patrón y seguir
              repitiéndolo, porque el patrón está en el lugar desde donde mirás.
            </p>
            <div className="mt-8 pt-8 border-t border-charcoal-light" data-id="element-334" data-mp="3b01nbrelps0c">
              <p className="text-xl font-heading font-bold text-sand" data-id="element-335" data-mp="3ey942m92etbj">
                Por eso trabajo uno a uno con vos.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}